export default __webpack_public_path__ + "static/media/login_bg_keto@2x.38bfd3aa.jpg";